var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnviar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Send") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,9.41176471 L19,5 L14.5882353,20 L11.0588235,12.9411765 L4,9.41176471 Z",
    id: "shape-1",
    stroke: "#030819",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,13 L19,5",
    id: "shape-2",
    stroke: "#030819",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviar);
export default __webpack_public_path__ + "static/media/enviar.7146dd74455dbdfd3428b4fad2c0ff00.svg";
export { ForwardRef as ReactComponent };